exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.answer[data-v-cd81be44] {\n\tborder-top: 2px solid #2884e0;\n}\n.answer-head[data-v-cd81be44] {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n#answer-head-question[data-v-cd81be44] {\n\tmargin: 0 15px 0 0;\n\ttext-align: left;\n}\n#answer-head-category[data-v-cd81be44] {\n\tpadding: 5px;\n\tbackground-color: #2884e0;\n\tcolor: #fff;\n\tfont-size: 10pt;\n\tmargin-left: 10px !important;\n}\n", ""]);

// exports
